import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Settings2 } from 'lucide-react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useAuth } from '@/auth/context/AuthContext'
import { LaboratoriosTab } from '@/modules/multichannel/components/config/LaboratoriosTab'
import { MarcasTab } from '@/modules/multichannel/components/config/MarcasTab'
import { ConfiguracionesTab } from '@/modules/multichannel/components/config/ConfiguracionesTab'
import { ConfigGeneralTab } from '@/modules/multichannel/components/config/ConfigGeneralTab'
import { BenchmarksTab } from '@/modules/multichannel/components/config/BenchmarksTab'
import { VariacionesTab } from '@/modules/multichannel/components/config/VariacionesTab'

export function ConfiguracionCampanias() {
  const navigate = useNavigate()
  const { user, isLoading: authLoading } = useAuth()

  const isTonalAdmin = user?.groups?.includes('admin') || user?.is_superuser

  useEffect(() => {
    if (!authLoading && !isTonalAdmin) {
      navigate('/multichannel/seguimiento', { replace: true })
    }
  }, [authLoading, isTonalAdmin, navigate])

  if (authLoading || !isTonalAdmin) return null

  return (
    <div className="space-y-6">
      <div className="flex items-center">
        <h1 className="text-3xl font-bold tracking-tight flex items-center gap-2">
          <Settings2 className="h-6 w-6" />
          Configuracion de Campanas
        </h1>
      </div>

      <Tabs defaultValue="laboratorios" className="w-full">
        <TabsList className="grid w-full grid-cols-6">
          <TabsTrigger value="laboratorios">Laboratorios</TabsTrigger>
          <TabsTrigger value="marcas">Marcas</TabsTrigger>
          <TabsTrigger value="configuraciones">Configuraciones</TabsTrigger>
          <TabsTrigger value="general">General</TabsTrigger>
          <TabsTrigger value="benchmarks">Benchmarks</TabsTrigger>
          <TabsTrigger value="variaciones">Variaciones</TabsTrigger>
        </TabsList>
        <TabsContent value="laboratorios">
          <LaboratoriosTab />
        </TabsContent>
        <TabsContent value="marcas">
          <MarcasTab />
        </TabsContent>
        <TabsContent value="configuraciones">
          <ConfiguracionesTab />
        </TabsContent>
        <TabsContent value="general">
          <ConfigGeneralTab />
        </TabsContent>
        <TabsContent value="benchmarks">
          <BenchmarksTab />
        </TabsContent>
        <TabsContent value="variaciones">
          <VariacionesTab />
        </TabsContent>
      </Tabs>
    </div>
  )
}
